const state = {
    // 导航栏数据
    navDataArray: [],
    // 复习包类型id
    packageTypeId: '',
    resourceConfigPageQuery: '',
    regionId:'',
    reviewCourseId:''
};

const mutations = {
    saveNavDataArray: (state, value) => {
        state.navDataArray = value
    },
    savePackageTypeId: (state, value) => {
        state.packageTypeId = value
    },
    saveRegionId: (state, value) => {
        state.regionId = value
    },
    saveReviewCourseId: (state, value) => {
        state.reviewCourseId = value
    },
    saveResourceConfigPageQuery: (state, value) => {
        state.resourceConfigPageQuery = value
    },

};

export default {
    state,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/reviewManage.js